// fix_issue3.md #1 - the "duplicate 1-gram only" disclaimer. Shown on the jewellery portal
// (listings + detail + list/edit-a-piece form), in the footer of every page, and in the Terms.
// v3_fix_issues #9 - rendered as plain, low-key text, NOT a highlighted banner.
export const METAL_NOTICE =
  'RentalVerse deals exclusively in duplicate 1-gram jewellery. We do not rent or facilitate the ' +
  'rental of original / real gold or other precious-metal jewellery.';

export default function JewelleryMetalNotice({ className = 'mb-3' }) {
  return (
    <p className={`small text-muted ${className}`}>{METAL_NOTICE}</p>
  );
}
